export default "__VITE_ASSET__jI8$yhMh__"